import React from "react";
import "../../Shared/Shared.css";
import { Link } from 'react-router-dom'

export default function FooterAbout() {
  return (
    <section className="w-[90%] md:w-[80%] mx-auto pt-10 pb-16">
      <div className="md:mt-6">
        <Link to="/" className="text-[34px] font-semibold logo">
          Amir
          <span className="w-[7px] h-[7px] bg-[#D46868] rounded-full inline-block relative bottom-[-2px] ml-[5px]"></span>
        </Link>
      </div>
      <div className="grid md:grid-cols-4 md:gap-x-20 mb-6">
        <h4 className="mt-2 text-left md:text-left md:col-span-2 text-gray-300">
          I'm a self-motivated and hardworking person who always seeks new
          challenges. I am excited to learn, grow and eager to explore new
          technologies. <br />
          <span className="mt-4 inline-block">
            I try to ensures that every website I create is both visually and
            highly attractive & functional. I'm comfortable working
            independently or as part of a collaborative team. I value the
            importance of a pixel-perfect website development and creating
            high-quality web application.
          </span>
        </h4>
        <div className="mt-10 md:mt-0">
          <h5 className="text-[20px] md:text-[22px] font-semibold mb-4 md:mb-8 text-slate-100/90">
            Pages
          </h5>
          <ul className="flex flex-col gap-y-1 md:gap-y-3 font-semibold text-[#ddd]">
            <li>
              <Link
                className="hover:bg-slate-500/10 inline-block py-2 rounded-md px-1 w-full"
                to="/"
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                className="hover:bg-slate-500/10 inline-block py-2 rounded-md px-1 w-full"
                to="/"
              >
                Blogs
              </Link>
            </li>
            <li>
              <Link
                className="hover:bg-slate-500/10 inline-block py-2 rounded-md px-1 w-full"
                to="/"
              >
                Development Process
              </Link>
            </li>
          </ul>
        </div>
        <div className="mt-4 md:mt-0">
          <h5 className="text-[20px] md:text-[22px] font-semibold mb-4 md:mb-8 text-slate-100/90">
            Explore
          </h5>
          <ul className="flex flex-col gap-y-1 md:gap-y-3 font-semibold text-[#eee]">
            <li>
              <a
                className="hover:bg-slate-500/10 inline-block py-2 rounded-md px-1 w-full"
                href="/#about"
              >
                About
              </a>
            </li>
            <li>
              <a
                className="hover:bg-slate-500/10 inline-block py-2 rounded-md px-1 w-full"
                href="/#skills"
              >
                Skills
              </a>
            </li>
            <li>
              <a
                className="hover:bg-slate-500/10 inline-block py-2 rounded-md px-1 w-full"
                href="https://drive.google.com/file/d/1EM-0RoKZoxV4Xx1CTyCCr3c2Z69CfsNy/view"
                target="_blank"
              >
                Resume
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
